export const greeting = 'Hi, My name is';
export const myName = ' K Prabina Choudhury.';
export const intro =
	'I am a Full Stack Developer. I build things for web.';
